


























import Vue from "vue";
import { myPlans } from "@/api/my";
import _ from "lodash";
import MyPlanCard from "@/views/my/MyPlanCard.vue";
import { datetimeFormat } from "@/utils/lang";
import { createNamespacedHelpers } from "vuex";

const { mapGetters, mapActions } = createNamespacedHelpers("config");

export default Vue.extend({
    name: "MyPlans",
    components: { MyPlanCard },
    data() {
        return {
            loading: false,
            finished: false,
            refreshing: false,
            isPlanFilterShow: false,
            myPlanList: new Array(0),
            finishText: this.$t("home.finishedText"),
            total: 0,
            pagination: {
                size: 10,
                page: 0
            }
        };
    },
    async mounted() {
        this.doQuery();
        await this.getOrgConfig();
    },
    methods: {
        ...mapActions(["getOrgConfig"]),
        onLoad() {
            if (this.refreshing) {
                this.myPlanList = [];
                this.refreshing = false;
            }
            this.doQuery();
        },
        doQuery() {
            this.loading = true;
            this.finishText = this.$t("home.finishedText");
            myPlans(this.pagination)
                .then(resp => {
                    if (resp.data) {
                        const pageData = resp.data.data;
                        this.total = resp.data.page.totalElements;
                        if (_.isEmpty(pageData) && _.isEmpty(this.myPlanList)) {
                            this.finishText = "";
                        }
                        if (_.isEmpty(pageData)) {
                            this.finished = true;
                            return;
                        }
                        this.myPlanList = _.concat(this.myPlanList, this.mapperList(pageData));

                        if (this.myPlanList.length <= this.pagination.size) {
                            this.finishText = "";
                        }
                        if (this.myPlanList.length >= this.total) {
                            this.finished = true;
                        }
                    }
                })
                .catch(error => {
                    this.finishText = "";
                    this.finished = true;
                })
                .finally(() => (this.loading = false));
        },
        mapperList(responseData) {
            return _.map(responseData, data => {
                const occupationInfo = data.program.occupationInfo || {};
                let coverPath = "";
                if (data.introduction.cover) {
                    coverPath = data.introduction.cover.thumbnailUrl;
                }
                return {
                    orgName: data.org.name,
                    enrollmentStudentId: data.enrollmentStudentId,
                    needImproved: !data.matchRequiredAttachments,
                    planId: data.planId,
                    planName: "(" + data.year + ") " + data.planName,
                    planVersion: data.planVersion,
                    certificateType: data.certificateType,
                    timeRange:
                        datetimeFormat(data.planStartTime, this.$constants.DATE_FMT) +
                        " - " +
                        datetimeFormat(data.planEndTime, this.$constants.DATE_FMT),
                    graduationStatus: data.graduationStatus,
                    studentId: data.studentId,
                    classificationName: occupationInfo.classificationName,
                    occupationName: occupationInfo.occupationName,
                    level: occupationInfo.occupationLevel,
                    approvalStatus: data.approvalStatus,
                    paymentStatus: data.paymentStatus,
                    coverPath: coverPath || require("@/assets/plan-default-cover.png"),
                    createAt: data.createAt
                };
            });
        },
        resetPage() {
            this.pagination.size = 10;
            this.pagination.page = 0;
        },
        onRefresh() {
            this.finished = false;
            this.resetPage();
            this.onLoad();
        }
    },
    computed: {
        ...mapGetters(["orgConfig"])
    }
});
